import { Util } from '@antv/g6';
import { DrawOpts, NodeModel } from '../../../../types';
import { getWidthNeededForAnchors, getTextWidth, getNodeTitle } from '../../../../shapes/utils';
import { DEFAULT_NODE_SIZE, shapeNames } from '../../../../shapes/constants';
import { getInfoX } from './text';

export const getMinHeightNeeded = ({ options }: Pick<DrawOpts, 'options'>) => {
  const { size = DEFAULT_NODE_SIZE } = options || {};
  const [, minHeight] = size;

  return minHeight;
};

const getWidthNeededForTitle = ({ options, model }: Pick<DrawOpts, 'options' | 'model'>) => {
  const titleWidth = getTextWidth(
    getNodeTitle(model as NodeModel, options),
    options[shapeNames.title],
  );
  const [, paddingRight] = Util.formatPadding(options?.padding);

  return titleWidth + getInfoX(options) + paddingRight;
};

export const getMinWidthNeeded = ({ group, options, model }: Omit<DrawOpts, 'size'>) => {
  const { size = DEFAULT_NODE_SIZE } = options || {};
  const [minWidth] = size;
  const { outputConnectors = [] } = model as NodeModel;

  return Math.max(
    minWidth,
    getWidthNeededForAnchors(outputConnectors.length, { group, options, model, size }),
    getWidthNeededForTitle({ options, model }),
  );
};

/** Most accurate way to get the current dimensions of the node */
export const getNodeDimensions = (group: DrawOpts['group']) =>
  group.findByClassName(shapeNames.wrapper).getBBox();

/** Most accurate way to get the current width of the node */
export const getNodeWidth = (group: DrawOpts['group']) => getNodeDimensions(group).width;

/** Most accurate way to get the current height of the node */
export const getNodeHeight = (group: DrawOpts['group']) => getNodeDimensions(group).height;
